<!-- https://echarts.apache.org/examples/zh/editor.html?c=mix-line-bar -->
<template>
  <div ref="chart" style="width: 100%; height: 500px;"></div>
</template>

<script>
import * as echarts from 'echarts'

export default {
  name: 'ECharts',
  props: {
    chartData: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      chartInstance: null,
      localChartData: null, // 本地数据副本
      initialChartData: null // 保存初始数据的副本
    }
  },
  mounted () {
    this.localChartData = JSON.parse(JSON.stringify(this.chartData)) // 初始化本地数据副本
    this.initialChartData = JSON.parse(JSON.stringify(this.chartData)) // 保存初始数据的副本
    this.initChart()
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize)
    if (this.chartInstance) {
      this.chartInstance.dispose()
    }
  },
  watch: {
    chartData: {
      handler (newVal) {
        if (this.chartInstance && newVal) {
          this.localChartData = JSON.parse(JSON.stringify(newVal))
          this.initialChartData = JSON.parse(JSON.stringify(newVal))
          this.updateChart()
        }
      },
      deep: true // 深度监听对象的变化
    }
  },
  methods: {
    initChart () {
      this.chartInstance = echarts.init(this.$refs.chart)
      this.updateChart()
      this.chartInstance.on('restore', this.handleRestore) // 监听 restore 事件
    },
    updateChart () {
      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        toolbox: {
          feature: {
            dataView: { show: true, readOnly: false },
            magicType: { show: true, type: ['line', 'bar'] },
            restore: { show: true },
            saveAsImage: { show: true }
          }
        },
        legend: {
          data: ['上架房源', '实勘数', '面访数', '无带看10-20', '无带看20+', '实勘率', '面访率']
        },
        xAxis: [
          {
            type: 'category',
            data: this.chartData.xAxisData,
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisLabel: {
              formatter: '{value} 套'
            }
          },
          {
            type: 'value',
            min: 0,
            max: 100,
            axisLabel: {
              formatter: '{value} %'
            }
          }
        ],
        series: [
          {
            name: '上架房源',
            type: 'bar',
            tooltip: {
              valueFormatter: function (value) {
                return value + ' 套'
              }
            },
            data: this.localChartData.seriesData.putOnTheShelfCount
          },
          {
            name: '实勘数',
            type: 'bar',
            tooltip: {
              valueFormatter: function (value) {
                return value + ' 套'
              }
            },
            data: this.localChartData.seriesData.actualExplorationCount
          },
          {
            name: '面访数',
            type: 'bar',
            tooltip: {
              valueFormatter: function (value) {
                return value + ' 套'
              }
            },
            data: this.localChartData.seriesData.interviewCount
          },
          {
            name: '无带看10-20',
            type: 'bar',
            tooltip: {
              valueFormatter: function (value) {
                return value + ' 套'
              }
            },
            data: this.localChartData.seriesData.watchWithoutStraps10
          },
          {
            name: '无带看20+',
            type: 'bar',
            tooltip: {
              valueFormatter: function (value) {
                return value + ' 套'
              }
            },
            data: this.localChartData.seriesData.watchWithoutStraps20
          },
          {
            name: '实勘率',
            type: 'line',
            smooth: true,
            yAxisIndex: 1,
            tooltip: {
              valueFormatter: function (value) {
                return value + ' %'
              }
            },
            data: this.localChartData.seriesData.actualExplorationRate
          },
          {
            name: '面访率',
            type: 'line',
            smooth: true,
            yAxisIndex: 1,
            tooltip: {
              valueFormatter: function (value) {
                return value + ' %'
              }
            },
            data: this.localChartData.seriesData.interviewRate
          }
        ]
      }
      this.chartInstance.setOption(option)
    },
    handleResize () {
      if (this.chartInstance) {
        this.chartInstance.resize()
      }
    },
    handleRestore () {
      // 使用初始数据副本恢复图表
      this.localChartData = JSON.parse(JSON.stringify(this.initialChartData))
      this.updateChart()
    }
  }
}
</script>

<style scoped lang="less">
/* 根据需要添加样式 */
</style>
